import { Box, Button, Link } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React from "react";
import SlidingPanel from "react-sliding-side-panel";
import CloseIcon from "@mui/icons-material/Close";
import SearchDropdown from "../../../../../Supporting files/SearchDropdown/SearchDropdown";
import DatePicker from "../../../../../Supporting files/DatePicker/DatePicker";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const EditFamilyMember: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [fullName, setFullName] = React.useState("Aman Raghuvanshi");
  const [relationship, setRelationship] = React.useState("Brother");
  const [memberDate, setMemberDate] = React.useState<Date | null>(new Date());

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  const relationship_data = [
    { label: "Husband", value: "Husband" },
    { label: "Wife", value: "Wife" },
    { label: "Father", value: "Father" },
    { label: "Mother", value: "Mother" },
    { label: "Brother", value: "Brother" },
    { label: "Sister", value: "Sister" },
    { label: "Son", value: "Son" },
    { label: "Daughter", value: "Daughter" },
    { label: "Father-in-Law", value: "Father-in-Law" },
    { label: "Mother-in-Law", value: "Mother-in-Law" },
  ];

  return (
    <>
      <SlidingPanel
        type={"right"}
        isOpen={open_status}
        size={75}
        panelClassName="slidingPanel"
        // backdropClicked={() => value_update(attrName, false)}
      >
        <>
          <Grid container spacing={2} alignItems="center">
            <Grid xs={10} className="headingTitle">
              <h3>
                <span>Edit Family Member</span>
              </h3>
              <p>
                To determine your ideal insurance requirements and better
                understand your risk score.
              </p>
            </Grid>
            <Grid xs={2} textAlign="right">
              <Link
                className="closeIcon"
                onClick={() => {
                  value_update(attrName, false);
                }}
              >
                <CloseIcon />
              </Link>
            </Grid>
            <Grid xs={12}>
              <hr />
            </Grid>
          </Grid>
          <Box className="scrollable_area">
            <Grid container spacing={3}>
              <Grid xs={6}>
                <RKTextField
                  class_name="inputField"
                  title={"Full Name"}
                  value={fullName}
                  attrName={setFullName}
                  value_update={updateMasterState}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={6}>
                <SearchDropdown
                  class_name="inputField"
                  title="Relationship"
                  value={relationship}
                  attrName={setRelationship}
                  value_update={updateMasterState}
                  data={relationship_data}
                  warn_status={false}
                  error_message={"please select relationship"}
                />
              </Grid>
              <Grid xs={6}>
                <DatePicker
                  class_name="inputField"
                  title="DOB"
                  value={memberDate}
                  attrName={setMemberDate}
                  value_update={updateMasterState}
                  error_message="Please enter DOB"
                  warn_status={false}
                />
              </Grid>
            </Grid>
          </Box>
          <Grid container spacing={3}>
            <Grid xs={12} className="ctaBtn mt-4">
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {}}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </>
      </SlidingPanel>
    </>
  );
};

export default EditFamilyMember;
